<template>
  <div class="page-container">
    <div
      class="row no-gutters border rounded overflow-hidden flex-md-row mb-4 p-4 shadow-sm h-md-250 position-relative"
    >
      <b-form @submit.prevent="onSubmit" class="col-12">
        <h5>Szczegóły reklamy</h5>
        <div class="row">
          <b-form-group
            id="input-group-name"
            label="Nazwa:"
            label-for="input-name"
            description=""
            class="col-6"
          >
            <b-form-input
              id="input-name"
              v-model="form.name"
              type="text"
              required
              placeholder="Wpisz nazwę pomocniczą reklamy"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-duration"
            label="Czas trwania:"
            label-for="input-duration"
            description="Wartość podaj w sekundach"
            class="col-6"
          >
            <b-form-input
              id="input-duration"
              v-model="form.duration"
              type="number"
              required
              placeholder="Podaj czas trwania reklamy w sekundach"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-banner_enabled"
            label-for="checkbox-banner_enabled"
            description=""
            class="col-6"
          >
            <b-form-checkbox
              id="checkbox-banner_enabled"
              v-model="form.banner_enabled"
              name="banner_enabled"
            >
              Reklama aktywna
            </b-form-checkbox>
          </b-form-group>
        </div>
        <hr class="col-12" />
        <div style="display: flex; gap: 10px;">
          <div style="">
            <h5>Reklama</h5>
          </div>
          <div>
            <b-button @click="uploadFile" class="btn-info">
              <template>
                <font-awesome-icon icon="upload" />
                Wgraj nową reklamę
              </template>
            </b-button>
            <b-button @click="reset" v-if="hasImageToUpload" class="btn-danger ml-2">
              <font-awesome-icon icon="trash" />
              Anuluj zmianę
            </b-button>
          </div>
        </div>
        <div v-if="!hasImageToUpload" class="row mt-3">
          <div class="col-12">
            <img
              v-if="firstLoadDone"
              :src="form.imageUrl"
              @click="show(form.imageUrl)"
              alt="zdjęcie"
              class="image-preview"
            />
          </div>
        </div>
        <div class="button-wrapper">
          <input hidden type="file" ref="file" @change="loadImage($event)" accept="image/*" />
        </div>
        <div class="cropper-container" v-if="hasImageToUpload">
          <div class="upload-example">
            <cropper
              ref="cropper"
              class="upload-example-cropper"
              :src="image.src"
              :min-height="minHeight"
              :default-size="defaultSize"
              :stencil-props="stencilProps"
            />
            <div class="vertical-buttons">
              <div class="square-button" @click="rotate(90)">
                <font-awesome-icon icon="redo" style="color: white;" />
              </div>
              <div class="square-button" @click="rotate(-90)">
                <font-awesome-icon icon="undo" style="color: white;" />
              </div>
              <div class="square-button" @click="changeAspectRatio">
                <font-awesome-icon icon="expand" style="color: white;" />
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 mt-3 row">
            <div class="col-12">
              <b-button type="submit" variant="primary">Zapisz reklamę</b-button>
            </div>
          </div>
        </div>
      </b-form>
    </div>
    <vue-easy-lightbox
      :visible="visible"
      :imgs="imgs"
      :index="index"
      @hide="handleHide"
      :scrollDisabled="true"
    ></vue-easy-lightbox>
  </div>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper'
import getMimeType from '@/utils/getMimeType'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'vue-advanced-cropper/dist/style.css'
import 'vue-advanced-cropper/dist/theme.classic.css'
import VueEasyLightbox from 'vue-easy-lightbox'
import axios from 'axios'

export default {
  name: 'EditBanner',
  components: {
    Cropper,
    VueEasyLightbox
  },
  async mounted() {
    const vm = this
    await vm.fetchBannerData()
    vm.firstLoadDone = true
  },
  data() {
    return {
      aspectRatio: 'empty',
      firstLoadDone: false,
      imgs: '',
      visible: false,
      index: 0,
      callbackUrl: '',
      hasImageToUpload: false,
      isUploadingFile: false,
      image: {
        src: null,
        type: null
      },
      form: {
        id: '',
        name: '',
        duration: 60,
        banner_enabled: true,
        imageUrl: '',
        imageFileKey: ''
      }
    }
  },
  computed: {
    minHeight() {
      return this.aspectRatio !== 'empty' ? 400 : 0
    },
    stencilProps() {
      let ratio = 16 / 9

      switch (this.aspectRatio) {
        case '1/1':
          ratio = 1
          break
        case '16/9':
          ratio = 16 / 9
          break
        case '9/16':
          ratio = 9 / 16
          break
        case 'empty':
        default:
          ratio = null
      }

      if (!ratio) {
        return {
          movable: true,
          resizable: true
        }
      }

      return {
        aspectRatio: ratio,
        movable: true,
        resizable: true
      }
    }
  },
  methods: {
    uploadFile() {
      this.aspectRatio = 'empty'
      this.$refs.file.click()
    },
    changeAspectRatio() {
      const currentAspectRatio = this.aspectRatio
      switch (currentAspectRatio) {
        case '1/1':
          this.aspectRatio = '16/9'
          break
        case '16/9':
          this.aspectRatio = '9/16'
          break
        case '9/16':
          this.aspectRatio = 'empty'
          break
        case 'empty':
        default:
          this.aspectRatio = '1/1'
      }
    },
    rotate(angle) {
      this.$refs.cropper.rotate(angle)
    },
    show(imgURL) {
      this.imgs = imgURL
      this.visible = true
    },
    handleHide() {
      this.visible = false
    },
    defaultSize({ imageSize, visibleArea }) {
      return {
        width: (visibleArea || imageSize).width,
        height: (visibleArea || imageSize).height
      }
    },
    reset() {
      this.image = {
        src: null,
        type: null
      }
      this.hasImageToUpload = false
      this.$refs.file.value = null
    },
    loadImage(event) {
      // Reference to the DOM input element
      const { files } = event.target
      // Ensure that you have a file before attempting to read it
      if (files && files[0]) {
        // 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
        if (this.image.src) {
          URL.revokeObjectURL(this.image.src)
        }
        // 2. Create the blob link to the file to optimize performance:
        const blob = URL.createObjectURL(files[0])

        // 3. The steps below are designated to determine a file mime type to use it during the
        // getting of a cropped image from the canvas. You can replace it them by the following string,
        // but the type will be derived from the extension and it can lead to an incorrect result:
        //
        // this.image = {
        //    src: blob;
        //    type: files[0].type
        // }

        // Create a new FileReader to read this image binary data
        const reader = new FileReader()
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.image" refers to the image of Vue component
          this.image = {
            // Set the image source (it will look like blob:http://example.com/2c5270a5-18b5-406e-a4fb-07427f5e7b94)
            src: blob,
            // Determine the image type to preserve it during the extracting the image from canvas:
            type: getMimeType(e.target.result, files[0].type)
          }
          this.hasImageToUpload = true
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsArrayBuffer(files[0])
      } else {
        this.editUser = {
          user_id: null
        }
      }
    },
    async fetchBannerData() {
      const vm = this
      vm.$store.commit('addPageLoaderEvent', 'fetchBannerData')
      try {
        const response = await vm.$http.post('e-zacma/banners/get', {
          id: Number(vm.$route.params.id)
        })
        vm.form.id = response.data.id
        vm.form.name = response.data.name
        vm.form.duration = response.data.duration
        vm.form.banner_enabled = response.data.enabled
        vm.form.imageUrl = response.data.image_url
      } catch (e) {
        vm.$error()
      } finally {
        vm.$store.commit('removePageLoaderEvent', 'fetchBannerData')
      }
    },
    async crop(afterUpload) {
      const { canvas } = this.$refs.cropper.getResult()
      await canvas.toBlob(async blob => {
        try {
          const response = await this.$http.post('e-zacma/banners/generate-presigned-url', {
            bannerName: this.form.name
          })

          const { url, fileName, s3BucketName, s3Region, directoryName } = response.data
          const instance = axios.create()
          delete instance.defaults.headers.common.Authorization

          await instance.put(url, blob, {
            headers: {
              'Content-Type': 'image/jpeg'
            }
          })

          const fileKey = `${directoryName}/${fileName}`
          const fileUrl = `https://${s3BucketName}.s3.${s3Region}.amazonaws.com/${fileKey}`

          this.form.imageFileKey = fileKey
          this.form.imageUrl = fileUrl

          if (afterUpload) {
            afterUpload()
          }
        } catch (error) {
          throw error
        }
      }, this.image.type)
    },
    async editBanner() {
      const vm = this
      try {
        const dataToUpdate = {
          id: vm.form.id,
          name: vm.form.name,
          duration: Number(vm.form.duration),
          enabled: vm.form.banner_enabled
        }

        if (vm.hasImageToUpload) {
          dataToUpdate.imageUrl = vm.form.imageUrl
          dataToUpdate.imageFileKey = vm.form.imageFileKey
        }

        await vm.$http.post('e-zacma/banners/edit', dataToUpdate)

        vm.$toast.success({
          title: 'Reklama Zapisana.',
          message: 'Reklama została pomyślnie edytowana.'
        })

        await vm.$router.push({ name: 'e-zacma-tablets-banners' })
      } catch (error) {
        console.log('error: ', error)
        vm.$error('Wystąpił błąd podczas edycji reklamy')
      } finally {
        vm.$store.commit('removePageLoaderEvent', 'edit-banner')
      }
    },
    async onSubmit() {
      const vm = this
      vm.$store.commit('addPageLoaderEvent', 'edit-banner')
      if (vm.hasImageToUpload) {
        try {
          await vm.crop(vm.editBanner)
        } catch (error) {
          vm.$error('Wystąpił błąd podczas edycji reklamy')
        }
      } else {
        try {
          await vm.editBanner()
        } catch (error) {
          vm.$error('Wystąpił błąd podczas edycji reklamy')
        }
      }
    }
  }
}
</script>

<style lang="scss">
.callback-container {
  width: 100%;
  margin-top: 20px;
  margin-left: -15px;
  display: flex;
  align-items: center;

  & > button {
    margin-top: 15px;
  }
}

.cropper-container {
  padding: 20px;
  width: 100%;
}

.image-preview {
  cursor: zoom-in;
  height: 200px;
}

.upload-example {
  overflow: hidden;
  position: relative;
  height: 50vh;
  display: flex;
  align-content: center;
  justify-content: center;

  & .vertical-buttons {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);

    & .square-button {
      background: rgba(black, 0.4);
      display: flex;
      align-items: center;
      justify-content: center;
      height: 42px;
      width: 42px;
      margin-bottom: 10px;
      cursor: pointer;
      transition: background 0.5s;

      &:hover {
        background: rgba(grey, 0.5);
      }
    }
  }

  &__cropper {
    border: solid 1px #eee;
    min-height: 300px;
    max-height: 500px;
    width: 100%;
  }

  &__cropper-wrapper {
    position: relative;
  }

  &__reset-button {
    position: absolute;
    right: 20px;
    bottom: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    width: 42px;
    background: rgba(#3fb37f, 0.7);
    transition: background 0.5s;
    &:hover {
      background: #3fb37f;
    }
  }

  &__buttons-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 17px;
  }

  &__button {
    border: none;
    outline: solid transparent;
    color: white;
    font-size: 16px;
    padding: 10px 20px;
    background: #3fb37f;
    cursor: pointer;
    transition: background 0.5s;
    margin: 0 16px;
    &:hover,
    &:focus {
      background: #38d890;
    }
    input {
      display: none;
    }
  }

  &__file-type {
    position: absolute;
    top: 20px;
    left: 20px;
    background: #0d0d0d;
    border-radius: 5px;
    padding: 0px 10px;
    padding-bottom: 2px;
    font-size: 12px;
    color: white;
  }
}
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
</style>
